import React, {useState} from 'react';
import API, {getMe, HandleError} from "./API";
import {User} from "./models/User";

const DEFAULT_STATE = {
    token: '',
    user: null,
    loading: false,
    ui: {
        pageTitle: '',
        isDrawerOpen: false,
        darkMode: false,
        soundFx: false,
        //server-side
        new_version: '',
        locale: '',
        courses: [],
        progress: {
            topic: {
                ID: 0,
                name: '',
                duration: 0
            },
            category: {
                ID: 0,
                name: '',
                image: '',
                topics_completed: 0,
                topics_total: 0,
                has_questions: false
            }
        }
    }
};

const AppContext = React.createContext({...DEFAULT_STATE});

export const AppDataProvider = ({ children }) => {

    let token = window.localStorage.getItem('token');
    if(token?.length <= 10)
        token = '';
    let soundFx = window.localStorage.getItem('soundFx');
    if(soundFx === 'enabled')
        soundFx = true
    else
        soundFx = false

    const _ui = {...DEFAULT_STATE.ui, soundFx: soundFx }
    const [data, setData] = useState({...DEFAULT_STATE, ui: {..._ui}, token: token});

    const login = (token, user, ui) => {
        setData({...data, token: token, user: user, ui: {...data.ui, ...ui} });
        window.localStorage.setItem('token', token);
    }

    const startLoading = () => {
        setData({...data, loading: true })
    }
    const stopLoading = () => {
        setData({...data, loading: false})
    }

    const hasToken = () => {
        return data.token?.length > 10;
    }

    const isLoggedIn = () => {
        return data.user !== null && data.user?.ID > 0 && data.token?.length > 10;
    }

    const clearLogin = () => {
        window.sessionStorage.clear()
        window.localStorage.setItem('token', '');
        setData({...data, token: '', user: null });
    }

    const logout = (just_clear) => {
        clearLogin()
        if(!just_clear)
            window.location.href = '/login';
    }

    const openDrawer = () => {
        let ui = {...data.ui}
        ui['isDrawerOpen'] = true;
        setData({...data, ui: ui })
    }
    const closeDrawer = () => {
        let ui = {...data.ui}
        ui['isDrawerOpen'] = false;
        setData({...data, ui: ui })
    }

    const toggleDrawer = () => {
        let ui = {...data.ui}
        ui['isDrawerOpen'] = !data.ui.isDrawerOpen;
        setData({...data, ui: ui })
    }

    const enableSoundFx = () => {
        let ui = {...data.ui}
        ui['soundFx'] = true;
        window.localStorage.setItem('soundFx', 'enabled');
        setData({...data, ui: ui })
    }
    const disableSoundFx = () => {
        let ui = {...data.ui}
        ui['soundFx'] = false;
        window.localStorage.setItem('soundFx', '');
        setData({...data, ui: ui })
    }
    const toggleSoundFx = () => {
        let ui = {...data.ui}
        ui['soundFx'] = !data.ui.soundFx;
        window.localStorage.setItem('soundFx', data.ui.soundFx ? '' : 'enabled');
        setData({...data, ui: ui })
    }
    const setUser = (user) => {
        setData({...data, user: user })
    }

    const setUI = (ui) => {
        setData({...data, ui: {...data.ui, ...ui} })
    }

    const refreshMe = async (enqueueSnackbar) => {
        try {
            const resMe = await getMe(data.token)
            if (resMe.status < 200 || resMe.status > 299)
                throw resMe

            login(data.token, new User(resMe.me), resMe.ui)
            return true
        }
        catch(e) {
            HandleError(e, 'Error', enqueueSnackbar, logout);
            return false
        }
    }

    const set = (newData) => {
        setData({...data, ...newData})
    }

    const stopSfx = () => {
        return; //todo: causes issue with short mp3 files
        const players = ['sfxCorrect', 'sfxWrong', 'sfxSuccess', 'sfxPerfect'];
        for(let x = 0; x < players.length; x++) {
            let sfx = window.document.getElementById(players[x])
            sfx.pause()
            sfx.currentTime = 0
        }
    }
    const _playSfx = (Source, force) => {
        if(!data.ui.soundFx && !force)
            return;

        const sfx = window.document.getElementById(Source);
        // sfx.pause()
        // sfx.currentTime = 0;
        sfx.volume = 0.5;
        sfx.autoplay = false
        //sfx.src = Source
        const audioPromise = sfx.play()
        if (audioPromise !== undefined) {
            audioPromise
                .then(_ => {
                    // autoplay started
                })
                .catch(err => {
                    // catch dom exception
                    console.error(err)
                })
        }
    }
    const playSfxCorrect = (force) => {
        _playSfx('sfxCorrect', force)
    }
    const playSfxWrong = (force) => {
        _playSfx('sfxWrong', force)
    }
    const playSfxSuccess= (force) => {
        _playSfx('sfxSuccess', force)
    }
    const playSfxPerfect = (force) => {
        _playSfx('sfxPerfect', force)
    }
    return (
        <AppContext.Provider value={{...data, set, login, isLoggedIn, logout, hasToken, openDrawer, closeDrawer, toggleDrawer,
            refreshMe, setUser, startLoading, stopLoading, setUI, clearLogin, playSfxCorrect, playSfxWrong, playSfxSuccess, playSfxPerfect, toggleSoundFx, stopSfx}}>
            {children}
        </AppContext.Provider>
    )
};

export default AppContext;